module.exports = __webpack_public_path__ + "img/analysis-comparison.27a2b463.svg";